import mixpanel from "mixpanel-browser";

import { getExpoEASConstant } from "@/utils/expoConstants";

import { validMixpanelEnvs } from "../../types";

export const resetMixpanelSession = () => {
  const env = getExpoEASConstant("deployEnv");
  if (validMixpanelEnvs.includes(env)) {
    mixpanel.reset();
  }
};
